import {INotamAI} from './airport';
import axiosClient, {firebaseClient} from '@/api/axios';
import {ATLAS_DB} from '@/config/firebase';

export const getAllSitmapNotes = (): Promise<any> => {
  return firebaseClient.get(`${ATLAS_DB}/sitmap-notes.json`);
};

export const getAllNotams = (): Promise<Record<string, INotamAI[]>> => {
  return firebaseClient.get(`${ATLAS_DB}/notams_airport_v2/notams.json`);
};

export const getAllFirNotams = (): Promise<Record<string, INotamAI[]>> => {
  return firebaseClient.get(`${ATLAS_DB}/notams_fir_v2/notams.json`);
};

export const getAllAirportNoteData = () => {
  return firebaseClient.get(`${ATLAS_DB}/airport_notes.json`);
};

export type TrafficData = {
  aircraft_type: string;
  arr_airport: string;
  baro_altitude: string;
  callsign: string;
  colour: string;
  dep_airport: string;
  lat: string;
  long: string;
  true_track: string;
  vertical_speed: string;
  track: any[];
};

export const getTrafficData = async (): Promise<[TrafficData]> => {
  return await firebaseClient.get(`${ATLAS_DB}/radar.json`);
};

export const getFirData = async (): Promise<any> => {
  return await axiosClient.post(`/ATLAS_tmm__get_all_fir`);
};
